export { default } from './MapWindStationPin';
